export const MediaOrientation = {
  Landscape: 'Landscape',
  Portrait: 'Portrait',
} as const;

export type MediaOrientation = keyof typeof MediaOrientation;
